import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AppIdsPage from '../pages/AppIdsPage';

function IllustrationAppIdsRouter({ user }) {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <AppIdsPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default IllustrationAppIdsRouter;
